/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step3_AiInputs */

const en_dr_step3_ai = /** @type {(inputs: Dr_Step3_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts a firm-specific hypothesis from the cards, suggests a test doable in a day`)
};

const id_dr_step3_ai = /** @type {(inputs: Dr_Step3_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merumuskan hipotesis firm-specific dari kartu, menyarankan uji yang bisa selesai satu hari`)
};

/**
* | output |
* | --- |
* | "Drafts a firm-specific hypothesis from the cards, suggests a test doable in a day" |
*
* @param {Dr_Step3_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step3_ai = /** @type {((inputs?: Dr_Step3_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step3_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step3_ai(inputs)
	return en_dr_step3_ai(inputs)
});